const productInfoAccordionItems = document.querySelectorAll('.product-info-accordion-item')
const productInfoAccordionButtons = document.querySelectorAll('.product-info-accordion-item__button')
productInfoAccordionButtons.forEach(piab => {
  piab.addEventListener('click', () => {
    const currentProductInfoAccordionItem = piab.closest('.product-info-accordion-item')
    const itemWasActive = currentProductInfoAccordionItem.dataset.isActive === 'true'
    productInfoAccordionItems.forEach(piai => {
      piai.dataset.isActive = 'false'
    })
    currentProductInfoAccordionItem.dataset.isActive = itemWasActive ? 'false' : 'true'
  })
})


const liveChatTriggerButtons = document.querySelectorAll('[data-link-title="live-chat"]')
if (liveChatTriggerButtons && liveChatTriggerButtons.length) {
  liveChatTriggerButtons.forEach(ltb => {
    ltb.addEventListener('click', (e) => {
      const beaconFrames = document.querySelectorAll('.Beacon iframe')
      let liveChatButton
      beaconFrames.forEach(bf => {
        const btn = bf.contentWindow.document.querySelector("button")
        if (btn) liveChatButton = btn
      })
      if (!liveChatButton) return
      e.preventDefault()
      liveChatButton.click()
    })
  })
}

$('#products_reviews').click(function() {
    $('html, body').animate({
      scrollTop: $('.featured-reviews').offset().top
    }, 500);
});

  $(".img_link_hero_section").hover(function () {
    $('body').toggleClass("box-hover");
  });

